import { useMutation } from "react-query";
import { LogenInstance, LotteInstance } from "../instance";
import Swal from "sweetalert2";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { loginState } from "../../stores/loginState";
import { addBarcodeResultState } from "../../stores/addbarcode/addBarcodeResultState";

// 운송장 수동 등록 API
export const useAddBarcode = (setIsLoading) => {
  const login = useRecoilValue(loginState);
  const setResult = useSetRecoilState(addBarcodeResultState);

  const mutation = useMutation(
    (data) => {
      if (login.company === "LOGEN") {
        return LogenInstance.post("/loin", {
          api: "dvAll",
          data,
        });
      }

      if (login.company === "LOTTE") {
        return LotteInstance.post("/loin", {
          api: "dvAll",
          data,
        });
      }

      return Promise.reject(new Error("Invalid company"));
    },
    {
      onSuccess: (data) => {
        if (data.result === "00" || data.result === "77") {
          setIsLoading(false);
          setResult(data.data[0]);
          Swal.fire({
            icon: "success",
            title: "등록 완료",
            html: `수동 등록이 완료되었습니다.<br/>등록 성공: ${
              data.data[0].count || 0
            } 건<br/>등록 실패: ${data.data[0].fail || 0} 건`,
            confirmButtonText: "확인",
          });
        } else if (data.result === "fail") {
          setIsLoading(false);
          Swal.fire({
            title: "Error!",
            icon: "error",
            text: "등록에 실패했습니다. 다시 등록해 주세요.",
            confirmButtonText: "확인",
          });
        }
      },
      onError: (error) => {
        setIsLoading(false);
        console.log(error);
      },
    },
  );

  return mutation;
};
